import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from '@pages/NoticeExtractor/components/Content';

export const UserNoticeExtractor = () => {
  return (
    <>
      <Helmet>
        <title>Notice Extractor - AutoScript</title>
      </Helmet>
      <Header title="Notice Extractor" />
      <Content />
    </>
  );
};
